import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  name: [
    {...makeRule()},
  ],
}

export let formRules = {
  customer: [
    {...makeRule('请输入所属客户', 'string')},
  ],
  custom: [
    {...makeRule('请输入门店系统', 'string')},
  ],
  marketname: [
    {...makeRule('请输入门店名称', 'string')},
  ],
  markettype: [
    {...makeRule('请选择门店类型', 'integer')},
  ],
  isee: [
    {...makeRule('请选择查理宝平台使用', 'integer')},
  ],
  is_chain: [
    {...makeRule('请选择是否连锁', 'integer')},
  ],
  city_level: [
    {...makeRule('请选择城市等级', 'integer')},
  ],
  gatherinfo_status: [
    {...makeRule('请选择信息状态', 'integer')},
  ],
  market_size: [
    {...makeRule('请选择门店规模', 'integer')},
  ],
  opening_hours_start: [
    {...makeRule('请输入营业开始时间', 'string')},
  ],
  opening_hours_end: [
    {...makeRule('请输入营业结束时间', 'string')},
  ],
  address: [
    {...makeRule('请输入地址', 'string')},
  ],
  provinceid: [
    {...makeRule('请选择省份', 'integer')},
  ],
  cityid: [
    {...makeRule('请选择城市', 'integer')},
  ],
  areaid: [
    {...makeRule('请选择地区', 'integer')},
  ],
  street: [
    {...makeRule('请输入街道', 'string')},
  ],
  street_number: [
    {...makeRule('请输入街道', 'string')},
  ],
  longitude: [
    {...makeRule('请输入百度经度', 'number')},
  ],
  latitude: [
    {...makeRule('请输入百度纬度', 'number')},
  ],
  lon_gd: [
    {...makeRule('请输入高德经度', 'number')},
  ],
  lat_gd: [
    {...makeRule('请输入高德纬度', 'number')},
  ],
  status: [
    {...makeRule('请输入状态', 'integer')},
  ]
}



// WEBPACK FOOTER //
// ./src/views/market/market.rules.js